import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

export const getOnboardingTimesByCityId = async cityId => {
  const query = `query (
    $cityId: ID!
   ){
    city(
        id: $cityId
        ){
            onboardingTimes {
                id
                type
                day
                timeStart
                timeStop
            }
    }
}`

  const response = await callAuthorizedGraphQLEndpoint(query, {
    cityId,
  })
  return response.json()
}

export const addOnboardingTime = async payload => {
  const query = `mutation ($input:SetOnboardingTimesInput!){
    setOnboardingTimes(input:$input){
        onboardingTimes {
            id
            day
            type
            timeStart
            timeStop
        }
    }
}`

  const response = await callAuthorizedGraphQLEndpoint(query, {
    input: { cityId: payload.cityId, onboardingTimes: payload.onboardingTimes },
  })
  return response.json()
}

export const removeOnboardingTime = async id => {
  const query = `mutation ($input:DeleteOnboardingTimesInput!){
    deleteOnboardingTimes(input:$input){
        success
        deletedIds
    }
}`

  const response = await callAuthorizedGraphQLEndpoint(query, {
    input: { ids: id },
  })
  return response.json()
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/OnboardingTimes/gql.js